<template>
    <v-container fluid>
      <v-row>
        <v-col class="col-12">
          <h1>All Jobs</h1>
          <v-simple-table
            fixed-header
            height="450px"
          >
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Job No</th>
                  <th class="text-left">Customer</th>
                  <th class="text-left">Date</th>
                  <th class="text-left">Site</th>
                  <th class="text-left">Value</th>
                  <th class="text-left">By</th>
                  <th class="text-left">Status</th>
                  <th class="text-left">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="job in jobs"
                  :key="job.id"
                >
                  <td>{{ job.jobNumber }}</td>
                  <td>{{ job.customer }}</td>
                  <td>{{ job.date | tinyDate }}</td>
                  <td>{{ job.site }}</td>
                  <td>
                    <span v-if="job.value > job.minChargeAmount">
                      {{ job.value | priceInPounds | currency }}
                    </span>
                    <span v-else>
                      {{ job.minChargeAmount | priceInPounds | currency }}
                    </span>
                  </td>
                  <td>{{ job.quotedByInitials }}</td>
                  <td>
                    <span v-if="job.status === 0">Not planned</span>
                    <span v-if="job.status === 1">Planned</span>
                    <span v-if="job.status === 2">Complete</span>
                    <span v-if="job.status === 3">Authorised</span>
                    <span v-if="job.status === 4">Invoiced</span>
                  </td>
                  <td class="pr-0">
                    <router-link custom v-slot="{ navigate }" :to="`/reports/job-financial-overview/${job.id}`">
                      <v-btn
                        title="View"
                        x-small
                        @click="navigate"
                        @keypress.enter="navigate"
                        role="link">
                          View
                      </v-btn>
                    </router-link>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <v-pagination
            class="pt-4"
            v-model="page"
            :length="length"
            prev-icon="mdi-menu-left"
            next-icon="mdi-menu-right"
            :total-visible="totalVisible"
          ></v-pagination>
        </v-col>
      </v-row>
      <router-view></router-view>
    </v-container>
  </template>
  
  <script>
  import axios from '../../axios';
  
  export default {
    name: 'LiveJobsIndex',
    computed: {
      token() {
        return this.$store.state.token;
      },
    },
    data() {
      return {
        jobs: [],
        page: 1,
        length: 0,
        totalVisible: 9,
        total: 0,
      };
    },
    watch: {
      page() {
        this.getJobs();
      },
    },
    methods: {
      getJobs() {
        axios.get(`/liveJobs/getAll/${this.page}.json?token=${this.token}`)
          .then((response) => {
            this.jobs = response.data.jobs;
            this.length = response.data.length;
            this.total = response.data.total;
          })
          .catch((error) => {
            console.log(error);
          });
      },
    },
    mounted() {
      this.getJobs();
    },
  };
  </script>
  